/* eslint-disable react/prop-types */
import * as React from 'react';
import classnames from 'classnames';

import { expandDataProps } from 'utils/helper/common';

import type { Data } from 'types';

import type { SyntheticEvent } from 'react';

type Props = {
  name: string | undefined | null,
  width?: unknown,
  height?: unknown,
  clickable?: boolean,
  link?: string,
  isBackgroundContain?: boolean, // this prop will set background-size: contain,
  isBackgroundCenter?: boolean, // this prop will set background-position: center center;,
  className?: string,
  onClick?: (a: SyntheticEvent<HTMLSpanElement>) => void,
  data?: Data,
  href?: string
};

// @todo: rename to Icon if we use it for all icons
/**
 * @description For static icons only
 */
const SVGIcon = (
  {
    name,
    width,
    height,
    clickable,
    link,
    isBackgroundContain = false,
    isBackgroundCenter = false,
    className = '',
    onClick,
    data
  }: Props
): JSX.Element => {
  const classes = classnames({
    'svg-icon': true,
    'svg-icon--behavior-clickable': onClick || clickable,
    [`svg-icon--name-${String(name)}`]: name,
    [String(className)]: Boolean(className)
  });

  const props: React.ComponentProps<'a'> = {};
  let style = {};

  props.className = classes;

  if (onClick) {
    props.onClick = onClick;
  }

  if (link) {
    props.href = link;
  }

  if (isBackgroundContain) {
    style = {
      ...style,
      backgroundSize: 'contain'
    };
  }

  if (isBackgroundCenter) {
    style = {
      ...style,
      backgroundPosition: 'center center'
    };
  }

  if (width) {
    style = {
      ...style,
      width
    };
  }

  if (height) {
    style = {
      ...style,
      height
    };
  }

  const icon = (
    <span
      style={style}
      {...props}
      {...expandDataProps(data)}
    />
  );

  return (
    props.href ?
      <a
        className="svg-icon__link"
        href={props.href}
        rel="noopener noreferrer"
        target="_blank"
        {...expandDataProps(data)}
      >
        {icon}
      </a> :
      icon
  );
};

export default SVGIcon;
